
import { withRouter, Link } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
//import { isObjectEmpty } from '../../utils';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { templateStyles } from '../../Styles/templateStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import FileDrop from 'react-file-drop';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import CloseIcon from '@material-ui/icons/Close';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Loader from 'react-loader-spinner'

const acceptedFiles = ['image/png', 'image/jpeg', 'application/zip', 'application/pdf', 'application/x-zip-compressed']
@inject('templateStore', 'commonStore')
@observer
class UploadTemplate extends React.Component {
    state = {
        showUploadStatus: false,
        validationErrors: {},
    }
    constructor() {
        super()
        this.inputOpenFileRef = React.createRef()
        this.zipInputFileRef = React.createRef()
    }

    closeDialog = () => {
        this.props.dashboardStore.closeUploadDialog();
        this.props.dashboardStore.resetFiles()
        this.setState({
            showUploadStatus: false
        })
    }

    openFileModal = () => {
        this.inputOpenFileRef.current.click();
    }

    handleDrop = (files, event) => {
        event.preventDefault();
        if (!files.length)
            return;
        if (!this.validateFiles(files)) {
            this.props.commonStore.handleOpenSnackBar("Only PDF and image files are allowed!", "info");
            return;
        }
        this.props.templateStore.setUploadTemplate(files);
        this.setState({
            showUploadStatus: true
        })
    }

    removeFile = (index) => {
        this.props.dashboardStore.removeFile(index)
    }

    uploadFiles = () => {
        const { files,templateName } = this.props.templateStore
        if (this.props.templateStore.files.length > 1) {
            this.props.commonStore.handleOpenSnackBar("Only one template can be created at a time!!", "info")
            return;
        }
        if (!templateName.replace(/\s/g, '').length) {
            this.props.commonStore.handleOpenSnackBar("Please define the template name before proceeding", "info")
            return;
        }
        if (files.length)
            this.props.templateStore.uploadTemplate();
        else {
            this.props.commonStore.handleOpenSnackBar("Please choose a file before proceeding.", "info")
            return

        }
    }

    validateFiles = (files) => {
        let temp = []
        temp = temp.concat(Array.from(files))
        let valid = true

        temp.forEach(file => {
            if (acceptedFiles.indexOf(file.type.toLowerCase()) < 0)
                valid = false
        })
        return valid
    }

    onChangeFile = (event, type) => {
        event.stopPropagation();
        event.preventDefault();
        var files = event.target.files;
        if (!files.length)
            return;
        if (!this.validateFiles(files)) {
            this.props.commonStore.handleOpenSnackBar("Only PDF and image files are allowed!", "info");
            return;
        }
        this.props.templateStore.setUploadTemplate(files);
        this.setState({
            showUploadStatus: true
        })
    }

    removeFile = (index) => {
        this.props.templateStore.removeFile(index)
    }

    cancelUpload = () => {
        this.setState({ showUploadStatus: false })
        this.props.templateStore.cancelUpload()
    }

    getFileIcon = (name) => {
        let temp = 'png'
        if (name.toLowerCase().endsWith('.pdf'))
            temp = 'miniPdf'
        else if (name.toLowerCase().endsWith('.zip'))
            temp = 'folder'
        return Images[`${temp}`]
    }


    

    render() {
        const { uploadDialog, uploadProgress, uploadIcon, files, templateName } = this.props.templateStore;
        const { classes } = this.props;
        const { showUploadStatus, validationErrors } = this.state
        return (
            <Dialog BackdropProps={{
                classes: {
                    root: classes.backdrop
                }
            }} disableBackdropClick={true} disableEscapeKeyDown={true} classes={{ paper: classes.dialog }} open={uploadDialog} onClose={this.cancelUpload} aria-labelledby="form-dialog-title">
                <DialogContent>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <ReactSVG style={{ cursor: 'pointer' }} src={Images.cancel} onClick={(e) => this.cancelUpload()} />
                    </div>
                    {uploadIcon == "close" ?
                        <div>
                            <div>
                                <FileDrop onDrop={this.handleDrop}>
                                    <ReactSVG
                                        beforeInjection={svg => {
                                            svg.classList.add(classes.svg)
                                        }}
                                        src={Images.importDoc1} />
                                    <div style={{ color: 'white', textAlign: 'center', fontSize: '22px' }}>Drop File Here</div>
                                </FileDrop>
                            </div>

                            <div style={{ textAlign: 'center', color: 'gray' }}> or</div>
                            <div style={{ textAlign: 'center' }}>
                                <Button variant="contained" className={classes.button} type="submit" onClick={(e) => this.openFileModal()} >
                                    Choose Files
                            <input
                                        accept=".pdf,image/*"
                                        type="file"
                                        style={{ display: "none" }}
                                        ref={this.inputOpenFileRef}
                                        onChange={(e) => this.onChangeFile(e, false)}
                                    />
                                </Button>
                            </div>
                        </div> : null}
                    <div style={{ marginTop: '1vw', color: 'white' }}>Define template name</div>
                    <TextField style={{ paddingTop: 0, marginTop: '1vw' }}
                        required
                        id="name-input"
                        placeholder="Name*"
                        type="text"
                        name="name"
                        autoComplete="name"
                        margin="normal"
                        variant="filled"
                        fullWidth
                        InputProps={{
                            disableUnderline: true,
                            classes: {
                                input: classes.textFieldInput,
                            },
                        }}
                        value={templateName}
                        onChange={(event) => this.props.templateStore.handleNameChange(event.target.value )}
                    />
                    {files.length ?
                        <div style={{ marginTop: '1vw' }}>
                            {
                                files.map((row, index) => (
                                    <div style={{ color: 'white', display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ display: 'flex' }}>
                                            <div><ReactSVG beforeInjection={svg => { svg.classList.add(classes.icons) }} src={this.getFileIcon(row.name)} /></div>
                                            <div style={{ paddingTop: '1vh' }} >{row.name} </div>
                                        </div>
                                        {uploadIcon === "close" ?
                                            <CloseIcon style={{ cursor: 'pointer' }} onClick={(e) => this.removeFile(index)} /> : (uploadIcon === "progress" ? <Loader height={30} width={30} type="Oval" color={this.props.theme.palette.turquoise} /> :
                                                (uploadIcon === "right" ? <ReactSVG src={Images.progressDone} /> : <ReactSVG src={Images.error} />)
                                            )}
                                    </div>
                                ))
                            }
                        </div> : null}
                    {showUploadStatus ? (!uploadProgress && uploadIcon === "close" ? <div style={{ display: 'flex', flexDirection: 'row', marginTop: '10vh', justifyContent: 'center' }}>
                        <Button style={{ width: '7vw', marginTop: 0, marginBottom: '20px', marginRight: '1vw', backgroundColor: '#acb4c6' }} variant="contained" className={classes.button} type="submit" onClick={(e) => this.cancelUpload()}>
                            Cancel
                </Button>
                        <Button style={{ width: '7vw', marginTop: 0, marginBottom: '20px' }} variant="contained" className={classes.button} type="submit" onClick={(e) => this.uploadFiles()}>
                            Upload
                </Button>
                    </div> : null) : null}
                </DialogContent>
            </Dialog>
        )
    }
}
export default withStyles(templateStyles, { withTheme: true })(withRouter(UploadTemplate));
